import React from 'react'
import Breadcrumb from '../1'
import { RealEstateDataPageComponentData } from 'types'
//Helpers

interface ExternalProps {
  titlePage: string
  noveltyId?: string
  developmentId?: string
  propertyId?: string
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps
const BreadCrumbs_1 = (props: CombinedProps) => {
  return <Breadcrumb {...props} />
}

export default BreadCrumbs_1
